const notDone = (done) => (r) => !done.includes(r.status);

export const PIPELINES = {
  crm: {
    path: "crm", title: "CRM & Inquiries", module: "crm", endpoint: "/inquiries", entityType: "inquiry",
    subtitle: "Manage inquiries through the full pipeline from first contact to completion.",
    labelKey: "name", subKey: "service",
    statuses: ["NEW", "CONTACTED", "FOLLOW_UP", "QUALIFIED", "ASSESSMENT", "SCHEDULED", "ACTIVE", "COMPLETED", "CLOSED", "LOST"],
    kpis: [
      { label: "New", filter: (r) => r.status === "NEW" },
      { label: "Follow-up", filter: (r) => r.status === "FOLLOW_UP" },
      { label: "Qualified", filter: (r) => r.status === "QUALIFIED" },
      { label: "Scheduled", filter: (r) => r.status === "SCHEDULED" },
      { label: "Active", filter: (r) => r.status === "ACTIVE" },
      { label: "Completed", filter: (r) => r.status === "COMPLETED" },
    ],
    columns: [
      { key: "name", label: "Name" }, { key: "service", label: "Service" },
      { key: "status", label: "Status", type: "badge" }, { key: "priority", label: "Priority", type: "badge" },
      { key: "reference_no", label: "Ref" }, { key: "created_at", label: "Received", type: "date" },
    ],
    detailFields: [
      { key: "email", label: "Email" }, { key: "phone", label: "Phone" },
      { key: "service", label: "Service" }, { key: "location", label: "Location" },
      { key: "source", label: "Source" }, { key: "priority", label: "Priority" },
    ],
    createFields: [
      { key: "name", label: "Name" }, { key: "email", label: "Email" }, { key: "phone", label: "Phone" },
      { key: "service", label: "Service" }, { key: "location", label: "Location" },
      { key: "priority", label: "Priority", type: "select", options: ["LOW", "MEDIUM", "HIGH"] },
      { key: "status", label: "Status", type: "select" },
    ],
  },
  referrals: {
    path: "referrals", title: "Referrals", module: "referrals", endpoint: "/referrals", entityType: "referral",
    subtitle: "Track partner and agency referrals through intake and approval.",
    labelKey: "client_name", subKey: "referrer",
    statuses: ["NEW", "REVIEWING", "CONTACTED", "ASSESSMENT", "APPROVED", "SCHEDULED", "ACTIVE", "COMPLETED", "DECLINED", "CLOSED"],
    kpis: [
      { label: "New", filter: (r) => r.status === "NEW" },
      { label: "Reviewing", filter: (r) => r.status === "REVIEWING" },
      { label: "Assessment", filter: (r) => r.status === "ASSESSMENT" },
      { label: "Approved", filter: (r) => r.status === "APPROVED" },
      { label: "Active", filter: (r) => r.status === "ACTIVE" },
      { label: "Completed", filter: (r) => r.status === "COMPLETED" },
    ],
    columns: [
      { key: "client_name", label: "Client" }, { key: "referrer", label: "Referred By" },
      { key: "service", label: "Service" }, { key: "urgency", label: "Urgency", type: "badge" },
      { key: "status", label: "Status", type: "badge" }, { key: "reference_no", label: "Ref" },
    ],
    detailFields: [
      { key: "referrer", label: "Referrer" }, { key: "referrer_org", label: "Organization" },
      { key: "client_name", label: "Client" }, { key: "client_phone", label: "Client Phone" },
      { key: "service", label: "Service" }, { key: "urgency", label: "Urgency" },
    ],
    createFields: [
      { key: "client_name", label: "Client Name" }, { key: "referrer", label: "Referred By" },
      { key: "referrer_org", label: "Organization" }, { key: "service", label: "Service" },
      { key: "urgency", label: "Urgency", type: "select", options: ["LOW", "MEDIUM", "HIGH"] },
      { key: "status", label: "Status", type: "select" },
    ],
  },
  applicants: {
    path: "applicants", title: "Applicants", module: "applicants", endpoint: "/applicants", entityType: "applicant",
    subtitle: "Recruitment pipeline from application to hire.",
    labelKey: "name", subKey: "position",
    statuses: ["NEW", "SCREENING", "INTERVIEW", "BACKGROUND_CHECK", "DOCUMENT_REVIEW", "APPROVED", "HIRED", "REJECTED", "WITHDRAWN"],
    kpis: [
      { label: "New", filter: (r) => r.status === "NEW" },
      { label: "Screening", filter: (r) => r.status === "SCREENING" },
      { label: "Interview", filter: (r) => r.status === "INTERVIEW" },
      { label: "Bg Check", filter: (r) => r.status === "BACKGROUND_CHECK" },
      { label: "Approved", filter: (r) => r.status === "APPROVED" },
      { label: "Hired", filter: (r) => r.status === "HIRED" },
    ],
    columns: [
      { key: "name", label: "Name" }, { key: "position", label: "Position" },
      { key: "email", label: "Email" }, { key: "status", label: "Status", type: "badge" },
      { key: "reference_no", label: "Ref" }, { key: "created_at", label: "Applied", type: "date" },
    ],
    detailFields: [
      { key: "email", label: "Email" }, { key: "phone", label: "Phone" },
      { key: "position", label: "Position" }, { key: "source", label: "Source" },
    ],
    createFields: [
      { key: "name", label: "Name" }, { key: "email", label: "Email" }, { key: "phone", label: "Phone" },
      { key: "position", label: "Position" }, { key: "status", label: "Status", type: "select" },
    ],
  },
};
